import { useRouter } from 'next/router';
import React from 'react';
import { paths } from 'src/config/paths';

import { Text } from '@/design-system/components/ui';
import { useConfirm } from '@/hooks/useConfirm';

interface CreateNewShortcutProps {
  entityType: 'trigger' | 'audience';
  projectSlug: string;
}

const CONFIG = {
  trigger: {
    question: 'Need to create a trigger?',
    linkText: 'Go to Triggers',
    suffix: 'and create all the ones you need before creating the incentive.',
    getPath: (slug: string) => paths.project.triggers.create(slug),
  },
  audience: {
    question: 'Need to create an audience?',
    linkText: 'Go to Audiences',
    suffix: 'and create the ones you need first.',
    getPath: (slug: string) => paths.project.affiliate.audiences.create(slug),
  },
};

export const CreateNewShortcut = ({ entityType, projectSlug }: CreateNewShortcutProps) => {
  const router = useRouter();
  const [ConfirmDialog, confirm] = useConfirm();
  const config = CONFIG[entityType];

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    const confirmed = await confirm({
      title: 'Leave this page?',
      message: 'All unsaved changes will be lost. Are you sure you want to continue?',
      confirmButtonText: 'Yes, leave',
      cancelButtonText: 'Cancel',
    });

    if (confirmed) {
      router.push(config.getPath(projectSlug));
    }
  };

  return (
    <>
      <Text variant="caption" color="muted">
        {config.question}{' '}
        <button
          type="button"
          onClick={handleClick}
          className="tw:underline tw:text-primary tw:cursor-pointer tw:bg-transparent tw:border-none tw:p-0 tw:align-baseline"
        >
          {config.linkText}
        </button>{' '}
        {config.suffix}
      </Text>
      {ConfirmDialog}
    </>
  );
};
